import { EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerGrid, EventHandlerObjectInput, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerDeleteAxisNetRelate } from "../event-handler/EHDeleteAxisNetRelate";

/**
 * 删除轴网图
 */
export class EventGraphDeleteAxisNet extends EventGraphBase {

    /**
     * delete_axis_net指令，删除轴网
     */
    static cmd: string = "DELETEAXISNET"

    generate(): void {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "",
                option: 'PARAMS',
                inputTypes: [PythaEventName.OBJECT]
            }]
        });
        const node3 = new EventGraphNode(this, EventHandlerObjectInput);
        const node4 = new EventGraphNode(this, EventHandlerDeleteAxisNetRelate);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node7 = new EventGraphNode(this, EventHandlerCmdEnd);

        this.addEdge(node1, node2);
        this.addEdge(node2, node3);
        this.addEdge(node3, node4);
        this.addEdge(node4, node5);
        this.addEdge(node5, node6);
        this.addEdge(node6, node7);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/136
    }
}